import React from "react";

const MobileBottomBar = ({
    cutOption, setCutOption,
    activePart, setActivePart,
    isConfirmed, hasPreSelectedPurchase,
    setActiveMobileView,
    setGuideTab, setIsGuideOpen,
}) => (
    <div className="d-flex d-md-none w-100 justify-content-between align-items-center px-3 pb-3 pt-2 position-absolute bottom-0 start-0 bg-transparent" style={{ zIndex: 1200, height: '80px', pointerEvents: 'none' }}>
        <div className="d-flex align-items-center gap-2" style={{ pointerEvents: 'auto' }}>
            <div className="btn-group shadow-sm p-1" style={{ backgroundColor: '#F6F5F0', borderRadius: '50px', border: '1px solid rgba(233, 228, 219, 0.8)', height: '48px' }}>
                {!hasPreSelectedPurchase && (
                    <button
                        className={`btn btn-sm rounded-pill fw-bold px-3 transition-all ${cutOption === 'free' ? 'text-white' : 'bg-transparent text-dark border-0'}`}
                        onClick={() => setCutOption('free')}
                        disabled={isConfirmed}
                        style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px', backgroundColor: cutOption === 'free' ? '#C5A075' : 'transparent' }}
                    >
                        <span
                            onClick={(e) => { e.stopPropagation(); setGuideTab('free'); setIsGuideOpen(true); }}
                            style={{ border: `1px solid ${cutOption === 'free' ? 'rgba(255,255,255,0.6)' : 'rgba(197,160,117,0.55)'}`, borderRadius: '50%', width: '16px', height: '16px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: cutOption === 'free' ? '#fff' : '#C5A075', fontSize: '10px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}
                        >?</span>
                        Free
                    </button>
                )}
                <button
                    className={`btn btn-sm rounded-pill fw-bold px-3 transition-all ${cutOption === 'preselected' ? 'text-white' : 'bg-transparent text-dark border-0'}`}
                    onClick={() => setCutOption('preselected')}
                    disabled={isConfirmed}
                    style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px', backgroundColor: cutOption === 'preselected' ? '#C5A075' : 'transparent' }}
                >
                    {hasPreSelectedPurchase && (
                        <span
                            onClick={(e) => { e.stopPropagation(); setGuideTab('preselected'); setIsGuideOpen(true); }}
                            style={{ border: `1px solid ${cutOption === 'preselected' ? 'rgba(255,255,255,0.6)' : 'rgba(197,160,117,0.55)'}`, borderRadius: '50%', width: '16px', height: '16px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: cutOption === 'preselected' ? '#fff' : '#C5A075', fontSize: '10px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}
                        >?</span>
                    )}
                    Pre
                </button>
            </div>
        </div>

        <div className="d-flex align-items-center gap-2" style={{ pointerEvents: 'auto' }}>
            <div className="btn-group shadow-sm p-1" style={{ backgroundColor: '#F6F5F0', borderRadius: '50px', border: '1px solid rgba(233, 228, 219, 0.8)', height: '48px' }}>
                <button className={`btn btn-sm rounded-pill fw-bold px-3 transition-all ${activePart === 'short' ? 'text-white' : 'bg-transparent text-dark border-0'}`} onClick={() => setActivePart('short')} disabled={isConfirmed} style={{ fontSize: '13px', backgroundColor: activePart === 'short' ? '#C5A075' : 'transparent' }}>Short</button>
                <button className={`btn btn-sm rounded-pill fw-bold px-3 transition-all ${activePart === 'long' ? 'text-white' : 'bg-transparent text-dark border-0'}`} onClick={() => setActivePart('long')} disabled={isConfirmed} style={{ fontSize: '13px', backgroundColor: activePart === 'long' ? '#C5A075' : 'transparent' }}>Long</button>
            </div>
            <button onClick={() => setActiveMobileView('preview')} className="btn rounded-pill fw-bold shadow-sm px-3" style={{ backgroundColor: '#C5A075', color: '#fff', height: '48px', border: 'none', fontSize: '13px' }}>Back</button>
        </div>
    </div>
);

export default MobileBottomBar;
